import React, { useEffect, useState } from "react";
import {
  Layout,
  PageHeader,
  Avatar,
  Tabs,
} from "antd";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import R2Footer from "../../../components/Footer";
import "./Customers.scss";
import CustomerFavorite from "./CustomerFavorite";
import CustomerOrders from "./CustomerOrders";
import CustomerProfile from "./CustomerProfile";
import CustomerService from "../../../services/CustomerService";
import moment from "moment";

const { Content } = Layout;
const { TabPane } = Tabs;
const CustomerDetails = () => {
  const [customers, setCustomers] = useState();
  const [customerOrders, setCustomerOrders] = useState([]);
  const [customerFav, setCustomerFav] = useState([]);
  const [state, setState] = useState({});
  const params = useParams();
  const adminRestaurant = useSelector((state) => state.admin);

  const history = useHistory();

  const handleChangetab = async (activeKey) => {};

  useEffect(() => {
    if (params.id) {
      getDetailsById(adminRestaurant, params.id);
      getCustomersOrders(adminRestaurant, params.id);
      getCustomersFavorite(adminRestaurant, params.id);
    }
  }, [params.id, adminRestaurant]);

  const getDetailsById = async (restId, id) => {
    const data = await CustomerService.getCustomerDetail(restId, id);
    setCustomers(data);
  };
  const getCustomersOrders = async (restId, id) => {
    const data = await CustomerService.getCustomerOrders(restId, id);
    setCustomerOrders(data);
  };

  const getCustomersFavorite = async (restId, id) => {
    const data = await CustomerService.getCustomerFav(restId, id);
    setCustomerFav(data);
  };

  return (
    <Layout className="u-page-layout">
      <Content className="w-full">
        <PageHeader
          title={`Customer Details`}
          onBack={() => history.goBack()}
        />
        {customers && (
          <div className="detail-header">
            <div className="image-name">
              <Avatar size="large">{customers.name?.substring(0, 1)}</Avatar>
              <div className="detail-heder-name">
                <div className="cust-detail-name">{customers.name}</div>
                <div className="cust-email">{customers.email}</div>
              </div>
            </div>
            <div className="detail-order-date">
              Last order date :{" "}
              {moment(customers.last_order_date).format("MM/DD/yyyy")}
            </div>
          </div>
        )}
        <Tabs
          className="customer-tab"
          defaultActiveKey="active"
          onChange={handleChangetab}
          size={"large"}
        >
          <TabPane tab="Profile" key="profile">
            <CustomerProfile customer={customers} />
          </TabPane>
          <TabPane tab="Favorite" key="favorite">
            <CustomerFavorite customerFav={customerFav} />
          </TabPane>
          <TabPane tab="Orders" key="orders">
            <CustomerOrders orders={customerOrders} />
          </TabPane>
        </Tabs>
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default CustomerDetails;
